import { LoadState } from "../../../constants/enums";

export interface IPhysicalDefaultCommissionState {
  list: IPhysicalDefaultCommission[];
  listLoading: LoadState;
  data: IPhysicalDefaultCommission;
  loading: LoadState;
  error: string | null;
}

export interface IPhysicalDefaultCommission {
  insurer_code: string | null;
  auto_percentage: null;
  home_percentage: string | null;
  commauto_percentage: string | null;
  business_percentage: string | null;
  status: "ACTIVE";
}

export const INITIAL_POLICY_DEFAULT_COMMISSION: IPhysicalDefaultCommission = {
  insurer_code: null,
  auto_percentage: null,
  home_percentage: null,
  commauto_percentage: null,
  business_percentage: null,
  status: "ACTIVE",
};

export const initialPhysicalDefaultCommissionState: IPhysicalDefaultCommissionState =
  {
    list: [],
    listLoading: LoadState.NotLoaded,
    data: INITIAL_POLICY_DEFAULT_COMMISSION,
    loading: LoadState.NotLoaded,
    error: null,
  };
